import React from "react";
import "../styles/Projects.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import ProjectCard from "./ProjectCard";

function Projects() {
  const navigate = useNavigate();

  return (
    <section id="projects-section" className="projects">
      <motion.h2
        className="projects-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Projects
      </motion.h2>

      <p className="proj-description">
        Projects I want to highlight — you can find more of my work on my{" "}
        <a href="https://github.com/yuliaFl">GitHub</a>.
      </p>

      <div className="cards">
        <ProjectCard
          title="Trana-Solutions.com"
          category="Freelance"
          description="Custom business website built with React."
          onClick={() => navigate("/TranaSolutions")}
        />
        <ProjectCard
          title="Fixiths.com"
          category="Freelance"
          description="Handyman service site created with React."
          onClick={() => navigate("/Fixiths")}
        />
        <ProjectCard
          title="Secure Chat App"
          category="College"
          description="Encrypted messaging application using Python."
          onClick={() => navigate("/SecureConnection")}
        />
        <ProjectCard
          title="Movies-n-me"
          category="College"
          description="Movie search app developed with React Native."
          onClick={() => navigate("/MoviesNMe")}
        />
        <ProjectCard
          title="WordFinder"
          category="College"
          description="Dictionary & thesaurus app built with React."
          onClick={() => navigate("/WordFinder")}
        />
        <ProjectCard
          title="BookStore"
          category="College"
          description="Online book catalog using Django."
          onClick={() => navigate("/BookStore")}
        />
      </div>
    </section>
  );
}

export default Projects;
